import React from 'react'
import SVGA from 'svgaplayerweb'
import Vap from 'video-animation-player'
import { getMediaType } from 'src/helper/tool'

import './index.less'

export default class extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props)
    this.mpRef = React.createRef()
  }

  state = {
    vapInstance: {},
    loadingInstance: {},
    loadingVisible: true,
    mediaType: ''
  }

  onCloseView = (e, o) => {
    e.stopPropagation()
    this.setState({
      loadingVisible: true
    })
    try {
      this.state.vapInstance.pause && this.state.vapInstance.pause()
      this.state.vapInstance.destroy && this.state.vapInstance.destroy()
    } catch (error) {
      console.error(error)
    }

    this.props.onClose()
  }
  init = () => {
    const loadingInstance = new SVGA.Player('#loadingCanvas')
    const loadoingParser = new SVGA.Parser('#loadingCanvas')
    loadoingParser.load('/img/activity/national-star/ani_web_loading.svga', (videoItem) => {
      loadingInstance.setVideoItem(videoItem)
      loadingInstance.startAnimation()
    })
    this.setState({
      loadingInstance
    })
  }

  initSVGA = () => {
    const that = this
    const { media } = that.props
    const player = new SVGA.Player('#preview-svga')
    const parser = new SVGA.Parser('#preview-svga')
    parser.load(media.show_url, (videoItem) => {
      that.loadingInstance && that.loadingInstance.stopAnimation()
      that.setState({
        loadingVisible: false
      })
      player.setVideoItem(videoItem)
      player.startAnimation()
    })
  }

  initVideo = () => {
    const that = this
    const { media } = that.props
    const vapInstance = new Vap({
      container: document.querySelector('#oiio'),
      // 素材视频链接
      src: media.show_url,
      // 素材配置json对象
      config: media.vap_json,
      // 同素材生成工具中配置的保持一致
      // 是否循环
      loop: true,
      // 起始播放时间点
      beginPoint: 0,
      // 精准模式
      type: 1,
      precache: true
    })
    vapInstance.on('playing', () => {
      that.loadingInstance && that.loadingInstance.stopAnimation()
      that.setState({
        loadingVisible: false
      })
    })
    that.setState({
      vapInstance: vapInstance
    })
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.visible &&
      JSON.stringify(this.props.media) !== JSON.stringify(prevProps.media)
    ) {
      const { media } = this.props
      if (media.show_url) {
        const mediaType = getMediaType(media.show_type, media.show_url)
        this.setState({
          mediaType
        })

        this.init()
        if (media && mediaType === 'mp4') {
          this.initVideo()
        }

        if (media && mediaType === 'svga') {
          this.initSVGA()
        }
      }
    }
  }

  render() {
    const { media, visible } = this.props
    const { loadingVisible } = this.state

    return (
      <div
        className={`preview-root ${visible ? 'active' : ''}`}
        onClick={e => this.onCloseView(e, 99)}
      >
        {
          media.show_url &&
          media.show_url.indexOf('.mp4') > -1 && (
            <div className="video-root">
              <div
                id="oiio"
                className="vpn-mpfive"
                ref={this.mpRef}
              ></div>
            </div>)
        }

        {
          media.show_url &&
          media.show_url.indexOf('.svga') > -1 && (
            <div className="video-root">
              <div
                className="preview-svga"
                id="preview-svga"
                style={{ textAlign: 'center' }}
              ></div>
            </div>
          )}

        {loadingVisible && (
          <div className="zhi-loader-compbox">
            <div
              className="chatie"
              id="loadingCanvas"
              src={`/img/ani_web_loading.svga`}
            ></div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national-star/media-modal/index.js